/**
 * trade
 * 支付API
 *
 * OpenAPI spec version: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import ApiClient from '../../ApiClient';




  /**
   * The OrderResultDto model module.
   * @module trade/model/OrderResultDto
   * @version 0.2.0
   */

  /**
   * Constructs a new <code>OrderResultDto</code>.
   * @alias module:trade/model/OrderResultDto
   * @class
   */
  var exports = function() {
    var _this = this;







  };

  /**
   * Constructs a <code>OrderResultDto</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:trade/model/OrderResultDto} obj Optional instance to populate.
   * @return {module:trade/model/OrderResultDto} The populated <code>OrderResultDto</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('appId')) {
        obj['appId'] = ApiClient.convertToType(data['appId'], 'String');
      }
      if (data.hasOwnProperty('timeStamp')) {
        obj['timeStamp'] = ApiClient.convertToType(data['timeStamp'], 'String');
      }
      if (data.hasOwnProperty('nonceStr')) {
        obj['nonceStr'] = ApiClient.convertToType(data['nonceStr'], 'String');
      }
      if (data.hasOwnProperty('package')) {
        obj['package'] = ApiClient.convertToType(data['package'], 'String');
      }
      if (data.hasOwnProperty('signType')) {
        obj['signType'] = ApiClient.convertToType(data['signType'], 'String');
      }
      if (data.hasOwnProperty('paySign')) {
        obj['paySign'] = ApiClient.convertToType(data['paySign'], 'String');
      }
    }
    return obj;
  }

  /**
   * 公众账号ID
   * @member {String} appId
   */
  exports.prototype['appId'] = undefined;
  /**
   * 时间戳
   * @member {String} timeStamp
   */
  exports.prototype['timeStamp'] = undefined;
  /**
   * 随机字符串
   * @member {String} nonceStr
   */
  exports.prototype['nonceStr'] = undefined;
  /**
   * 预支付会话标识，用于后续接口调用中使用，有效期2小时
   * @member {String} package
   */
  exports.prototype['package'] = undefined;
  /**
   * 加密方式
   * @member {String} signType
   */
  exports.prototype['signType'] = undefined;
  /**
   * 签名
   * @member {String} paySign
   */
  exports.prototype['paySign'] = undefined;



  export default exports;
;


